// Signs the user in when the ICC app opens this site in a WebView with a one-time ICC exchange code.
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppContext from "../../context/AppContext";
import ApiService from "../../api/ApiService";
import { exchangeCode } from "../../api/iccAuth";

const HANDOFF_KEY = "icc_webview_handoff";
const HANDLED_KEY = "icc_webview_handoff_sid";

export default function WebviewHandoff() {
  const { setToken, setUser } = useContext(AppContext);
  const navigate = useNavigate();

  useEffect(() => {
    let handoff = null;
    try {
      handoff = JSON.parse(localStorage.getItem(HANDOFF_KEY) || "null");
    } catch (e) {
      handoff = null;
    }
    // The ICC app re-injects the same payload on every page load; only a new sid means a new handoff.
    if (!handoff || !handoff.code || !handoff.sid || localStorage.getItem(HANDLED_KEY) === handoff.sid) return;
    localStorage.setItem(HANDLED_KEY, handoff.sid);

    (async () => {
      try {
        const session = await exchangeCode(handoff.code);
        const me = await ApiService.getMe();
        const signedIn = { ...me.user, menu: me.menu || [] };
        localStorage.setItem("user", JSON.stringify(signedIn));
        setToken(session.access_token);
        setUser(signedIn);
        navigate("/");
      } catch (err) {
        console.error("ICC handoff failed:", err);
      }
    })();
  }, [navigate, setToken, setUser]);

  return null;
}
